<template>
    <div class="documents-style">
        <!-- afrin 6-11 -->

        <!-- afrin 6-11 -->
        <!-- <div class="row no-gutters py-2 mb-3 border-bottom mt-3">
            <div class="col-sm-12 px-3 company-form-box-title">NOC Documents</div>
        </div> -->

        <div class="row no-gutters py-2 mb-3">
            <div class="col-sm-5 pr-2">
                <!-- <b-form-select v-model="filter_year" :options="fiscal_years" class="custom-select" @change="resetPagination()">
                    <template #first>
                        <b-form-select-option value="">Select Year</b-form-select-option>
                    </template>
                </b-form-select> -->
                <!-- <div class="col-sm-6 pl-0"> -->
                    <!-- Abdullah added class ess-leave-list for searchbox outer border -->
                <div class="align-self-center custom-search pr-0 mt-2 ess-leave-list" style="max-width: 480px; width: 100%;">
                    <b-input-group>
                        <b-input-group-prepend is-text>
                            <b-icon icon="search"></b-icon>
                        </b-input-group-prepend>
                        <b-form-input type="search" placeholder="Search" v-model="search" @input="resetPagination()"></b-form-input>
                    </b-input-group>
                </div>
            </div>
            <!-- </div> -->
            <!-- <div class="col-sm-3 pr-2"> -->
                <!-- <b-form-select v-model="filter_month" :options="months" class="custom-select" @change="resetPagination()"></b-form-select> -->
            <!-- </div> -->
            <div class="col-sm-7 cursor-pointer text-right company-form-box-title">
                <b-button @click="addNew()"><b-icon icon="plus"></b-icon> New Application</b-button>
            </div>
        </div>

       <!-- Abdullah removed class table-sticky-height  -->
        <div class="employee-table-wrapper ">
            <table class="employee-list-table table-overflow table-sticky ess-custom-table document-table tax-documents table-list fund_list_table document-custom-sorting-table-btn table-responsive">
                <thead>
                    <tr class="table-head">
                        <th @click="sortBy('employee_name')"
                            :class="sortKey === 'employee_name' ? (sortOrders['employee_name'] > 0 ? 'sorting_asc' : 'sorting_desc') : 'sorting'"
                            style="cursor:pointer;"><label class="custom-label-doc">Employee Name</label></th>
                        <th @click="sortBy('employee_code')"
                            :class="sortKey === 'employee_code' ? (sortOrders['employee_code'] > 0 ? 'sorting_asc' : 'sorting_desc') : 'sorting'"
                            style="cursor:pointer;"><label class="custom-label-doc">Employee Code</label></th>
                        <th @click="sortBy('noc_type')"
                            :class="sortKey === 'noc_type' ? (sortOrders['noc_type'] > 0 ? 'sorting_asc' : 'sorting_desc') : 'sorting'"
                            style="cursor:pointer;"><label class="custom-label-doc">NOC Type</label></th>
                        <th @click="sortBy('visiting_purpose')"
                            :class="sortKey === 'visiting_purpose' ? (sortOrders['visiting_purpose'] > 0 ? 'sorting_asc' : 'sorting_desc') : 'sorting'"
                            style="cursor:pointer;"><label class="custom-label-doc">Purpose</label></th>
                        <th @click="sortBy('visiting_destination')"
                            :class="sortKey === 'visiting_destination' ? (sortOrders['visiting_destination'] > 0 ? 'sorting_asc' : 'sorting_desc') : 'sorting'"
                            style="cursor:pointer;"><label class="custom-label-doc">Country's of Visit</label></th>
                        <th @click="sortBy('updated_at')"
                            :class="sortKey === 'updated_at' ? (sortOrders['updated_at'] > 0 ? 'sorting_asc' : 'sorting_desc') : 'sorting'"
                            style="cursor:pointer;"><label class="custom-label-doc">Last Activity</label></th>
                        <th @click="sortBy('status')"
                            :class="sortKey === 'status' ? (sortOrders['status'] > 0 ? 'sorting_asc' : 'sorting_desc') : 'sorting'"
                            style="cursor:pointer;"><label class="custom-label-doc">Status</label></th>
                        <th>Download</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="noc in paginatedData" :key="noc.id" class="hover-bg table-row border-bottom mx-2">
                        <!-- Afrin :update 6-9 -->
                        <td>{{ noc.employee ? noc.employee.name : '' }}</td>
                        <td>{{ noc.employee ? noc.employee.employee_code : '' }}</td>
                        <td>{{ noc.noc_type === 'general' ? 'General' : 'Travel' }}</td>
                        <td v-b-tooltip.hover :title="noc.visiting_purpose" style="max-width: 200px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                            {{ noc.visiting_purpose }}
                        </td>
                        <!-- <td>{{ noc.noc_type === 'general' ? 'N/A' : (noc.visiting_destination || '') }}</td> -->
                        <td>
                            <template v-if="noc.noc_type === 'general'">N/A</template>
                            <template v-else-if="noc.visiting_destination">
                                <div v-for="(line, index) in getCountryPairs(noc.visiting_destination)" :key="index">
                                    {{ line }}
                                </div>
                            </template>
                        </td>
                        <td>{{ format_datetime(noc.updated_at || noc.created_at) }}</td>
                        <!-- <td>
                            <template v-if="noc.status == 1">
                                <b-icon icon="check-circle-fill" variant="success" class="mr-2"></b-icon>
                            </template>
                            <template v-else-if="noc.status == 2">
                                <b-icon icon="x-circle-fill" variant="danger" class="mr-2"></b-icon>
                            </template>
                            <template v-else>
                                <b-icon icon="dash-circle-fill" variant="warning" class="mr-2"></b-icon>
                            </template>
                            {{ statusMap[noc.status] }}
                        </td> -->

                        <td class="text-center status-wrapper" :class="statusMap[noc.status] ? statusMap[noc.status].toLowerCase() : ''">
                            <span class="leave-status">
                                <i class="fa fa-circle mr-1"></i>{{ statusMap[noc.status] }}
                            </span>
                        </td>
                        <td>
                            <div class="col-sm-12 align-self-center mt-2 text-center" v-if="noc.status == 1">
                                <!-- <b-link @click="downloadNoc(noc.id)"> -->
                                <b-link @click="downloadFileContent(noc.file_name)">
                                    <img :src="$api_url+'/images/download_image.png'" class="" />
                                </b-link>
                            </div>
                        </td>
                        <td class="cursor-pointer trz_relative">
                            <div class="col-sm text-right clearfix align-self-center">
                                <a id="actionDropdown" class="dropdown-toggle clearfix action-dropdown-toggle"
                                    style="font-size: 16px;" href="#" role="button" data-toggle="dropdown"
                                    aria-haspopup="true" aria-expanded="false" v-if="noc.status != 1">
                                    <b-icon icon="three-dots-vertical"></b-icon>
                                </a>
                                <div class="dropdown-menu action-dropdown-menu documnet-btn" aria-labelledby="actionDropdown" v-if="noc.status != 1">
                                    <b-button-group>
                                        <b-button variant="outline-secondary" title="Edit" @click="editNoc(noc.id)" v-if="noc.status == 0">
                                            <b-icon icon="pencil"></b-icon> Edit
                                        </b-button>
                                        <b-button variant="outline-secondary" title="Delete" @click="deleteNoc(noc.id)" v-if="noc.status != 1">
                                            <b-icon icon="trash"></b-icon> Delete
                                        </b-button>
                                    </b-button-group>
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr v-if="noc_documents.length == 0">
                        <td colspan="9" class="text-center">No NOC documents found.</td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div class="row py-2 no-margin" v-if="filteredData.length > 0">
            <div class="col-md-12 p-0 no-margin">
                <ul class="pagination b-pagination float-left mb-0 mt-1">
                    <li class="page-item disabled m-2">View</li>
                    <li class="page-item disabled">
                        <b-form-select v-model="length" :options="length_options" @change="resetPagination()"></b-form-select> <!--Afrin: 7-15-->
                    </li>
                    <li class="page-item disabled m-2">per page. Total {{ filteredData.length }} records
                        found.</li>
                </ul>
                <!-- Afrin: 7-14 update start -->
                <b-pagination-nav class="float-right mt-1" v-model="pagination.currentPage"
                    :number-of-pages="totalPages" prev-text="Previous" next-text="Next" base-url="#" first-number
                    last-number></b-pagination-nav> 
                <!-- Afrin: 7-14 update end -->
            </div>
        </div>

        <!-- Abdullah chnaged spelling from NOC Applicatioin to NOC Application -->
        <b-modal id="bv-modal-noc" size="lg" :modal-class="'w-600'" hide-footer :title="fdata.id ? 'Edit NOC' : 'NOC Application'">
            <div class="custom-loader-wrapper" v-if="loader">
                <div class="text-center">
                    <img :src="$api_url+'/images/download-loader.svg'" class="loader-logo" width="100px"/>
                </div>
            </div>
            <b-form @submit.stop.prevent="onSubmit">
                <div class="row">
                    <!-- NOC Type Radio Buttons -->
                    <div class="col-md-12">
                        <!-- <b-form-radio-group v-model="fdata.noc_type" :options="[
                            { text: 'General NOC', value: 'general' },
                            { text: 'Travel NOC', value: 'travel' }
                        ]" buttons
                            button-variant="light"
                            class="noc-type-group w-100"
                            name="noc_type"
                            v-validate="'required'"
                            data-vv-as="NOC Type"
                            :state="validateState('noc_type')"
                            :disabled="fdata.id !== null"
                            @change="onNocTypeChange"
                        ></b-form-radio-group>

                        <b-form-invalid-feedback>
                            {{ veeErrors.first('noc_type') }}
                        </b-form-invalid-feedback> -->

                        <b-form-group class="noc-tab-legends">
                            <b-form-radio-group
                                class="noc-tab-btns w-100"
                                v-model="fdata.noc_type"
                                buttons button-variant="outline-secondary"
                                name="noc_type"
                                v-validate="'required'"
                                data-vv-as="NOC Type"
                                :state="validateState('noc_type')"
                                :disabled="fdata.id !== null"
                                @change="onNocTypeChange"
                            >
                                <b-form-radio value="general"><span>General NOC</span></b-form-radio>
                                <b-form-radio value="travel"><span>Travel NOC</span></b-form-radio>
                            </b-form-radio-group>
                            <b-form-invalid-feedback>
                                {{ veeErrors.first('noc_type') }}
                            </b-form-invalid-feedback>
                        </b-form-group>
                    </div>
                    <!-- Passport No (Travel only) -->
                    <div class="col-md-6 noc-mobile-padding" v-if="fdata.noc_type === 'travel'">
                        <b-form-group class="required-field">
                            <template #label>
                                Passport No.* <small class="text-muted" style="font-size: 11px; font-weight: normal; font-style: italic;">(from your employee profile)</small>
                            </template>
                            <b-form-input
                                v-model="fdata.passport_no"
                                v-validate="'required'"
                                name="passport_no"
                                data-vv-as="Passport No"
                                :state="validateState('passport_no')"
                                disabled
                            ></b-form-input>

                            <b-form-invalid-feedback>
                                {{ veeErrors.first('passport_no') }}
                            </b-form-invalid-feedback>
                        </b-form-group>
                    </div>
                    <!-- NEW: Nationality Field -->
                    <div class="col-md-6 noc-mobile-padding" v-if="fdata.noc_type === 'travel'">
                        <b-form-group class="required-field">
                            <template #label>
                                Nationality * <small class="text-muted" style="font-size: 11px; font-weight: normal; font-style: italic;">(from your employee profile)</small>
                            </template>
                            <b-form-input
                                v-model="fdata.nationality"
                                v-validate="'required'"
                                name="nationality"
                                data-vv-as="Nationality"
                                :state="validateState('nationality')"
                                disabled
                            ></b-form-input>
                            <b-form-invalid-feedback>{{ veeErrors.first('nationality') }}</b-form-invalid-feedback>
                        </b-form-group>
                    </div>
                    <!-- Passport Dates (Travel only) -->
                    <template v-if="fdata.noc_type === 'travel'">
                        <div class="col-md-6 noc-mobile-padding">
                            <b-form-group label="Passport Issue Date *" class="required-field">
                                <b-input-group>
                                    <b-form-input v-model="fdata.passport_issue_date" v-validate="'required|date_format:yyyy-MM-dd'" type="text" name="passport_issue_date"
                                        data-vv-as="Passport Issue Date"
                                        placeholder="YYYY-MM-DD" autocomplete="off" :state="validateState('passport_issue_date')"></b-form-input>
                                    <b-input-group-append>
                                        <b-form-datepicker v-model="fdata.passport_issue_date" button-only right
                                            reset-button close-button locale="en"

                                            name="passport_issue_date_picker"
                                            :max="maxPassportIssueDate"></b-form-datepicker>
                                    </b-input-group-append>
                                    <!-- afrin 6-11 -->
                                </b-input-group>
                                <!-- update for error box -->
                                <b-form-invalid-feedback :state="validateState('passport_issue_date')">{{ veeErrors.first('passport_issue_date') }}</b-form-invalid-feedback>
                            </b-form-group>
                        </div>
                        <div class="col-md-6 noc-mobile-padding">
                            <b-form-group label="Passport Expiry Date *" class="required-field">
                                <b-input-group>
                                    <b-form-input v-model="fdata.passport_expiry_date" v-validate="'required|date_format:yyyy-MM-dd'" type="text"
                                        name="passport_expiry_date" data-vv-as="Passport Expiry Date" placeholder="YYYY-MM-DD"
                                        autocomplete="off" :state="validateState('passport_expiry_date')"></b-form-input>
                                    <b-input-group-append>
                                        <b-form-datepicker v-model="fdata.passport_expiry_date" button-only right
                                            reset-button close-button locale="en"
                                            name="passport_expiry_date_picker"></b-form-datepicker>
                                    </b-input-group-append>
                                </b-input-group>
                                <!-- update for error box -->
                                <b-form-invalid-feedback :state="validateState('passport_expiry_date')">{{ veeErrors.first('passport_expiry_date') }}</b-form-invalid-feedback>
                            </b-form-group>
                        </div>
                    </template>

                    <!-- Purpose and Country -->
                    <div :class="[fdata.noc_type === 'general' ? 'col-md-12' : 'col-md-6', fdata.noc_type !== 'general' ? 'noc-mobile-padding' : '']">
                        <b-form-group label="Purpose *" class="required-field">
                            <b-form-input v-model="fdata.visiting_purpose" v-validate="'required'"
                                name="visiting_purpose" data-vv-as="Purpose" :state="validateState('visiting_purpose')"></b-form-input>
                            <b-form-invalid-feedback>{{ veeErrors.first('visiting_purpose')
                                }}</b-form-invalid-feedback>
                        </b-form-group>
                    </div>
                    <div class="col-md-6 noc-mobile-padding" v-if="fdata.noc_type === 'travel'">
                        <b-form-group label="Country's of Visit *" class="required-field">
                            <b-form-select v-model="temp_country" :options="countries"
                                :state="validateState('visiting_destination')" @change="onCountrySelect">
                                <template #first>
                                    <b-form-select-option :value="null">Select Country</b-form-select-option>
                                </template>
                            </b-form-select>
                            <input type="hidden" name="visiting_destination" v-model="fdata.visiting_destination" v-validate="'required'" data-vv-as="Country of Visit" />
                            <b-form-invalid-feedback>{{ veeErrors.first('visiting_destination') }}</b-form-invalid-feedback>
                            <div v-if="selectedCountries.length > 0" class="mt-2 d-flex flex-wrap">
                                <!-- // Afrin: edited 6-25-26 start -->
                                <span v-for="(country, index) in selectedCountries" :key="index" class="badge badge-info mr-2 mb-2 p-2 px-3 rounded-pill" style="font-size: 13px; display: inline-flex; align-items: center; background-color: #e8f0fe; color: #0d6efd; border: 1px solid #0d6efd;">
                                    {{ getCountryText(country) }}
                                    <b-icon icon="x" class="ml-2 cursor-pointer font-weight-bold" style="color: #0d6efd;" @click="removeCountry(country)"></b-icon>
                                </span>
                                <!-- // Afrin: edited 6-25-26 end -->
                            </div>
                        </b-form-group>
                    </div>

                    <!-- Start & End Date Fields (Always visible for both General and Travel types) -->
                    <div class="col-md-6 noc-mobile-padding">
                        <b-form-group label="Start Date *" class="required-field">
                            <b-input-group>
                                <b-form-input v-model="fdata.visiting_from_date" v-validate="'required|date_format:yyyy-MM-dd'"
                                    name="visiting_from_date" data-vv-as="Start Date" :state="validateState('visiting_from_date')" type="text"
                                    placeholder="YYYY-MM-DD" autocomplete="off"></b-form-input>
                                <b-input-group-append>
                                    <b-form-datepicker v-model="fdata.visiting_from_date" button-only right reset-button
                                        close-button locale="en" name="visiting_from_date_picker"
                                        :max="fdata.noc_type === 'travel' ? fdata.passport_expiry_date : null"></b-form-datepicker>
                                </b-input-group-append>
                                <!-- afrin 6-11 -->
                            </b-input-group>
                            <!-- update for error box -->
                            <b-form-invalid-feedback :state="validateState('visiting_from_date')">{{ veeErrors.first('visiting_from_date')
                                }}</b-form-invalid-feedback>
                        </b-form-group>
                    </div>
                    <div class="col-md-6 noc-mobile-padding">
                        <b-form-group label="End Date *" class="required-field">
                            <b-input-group>
                                <b-form-input v-model="fdata.visiting_to_date" v-validate="'required|date_format:yyyy-MM-dd'"
                                    name="visiting_to_date" data-vv-as="End Date" :state="validateState('visiting_to_date')" type="text"
                                    placeholder="YYYY-MM-DD" autocomplete="off"></b-form-input>
                                <b-input-group-append>
                                    <b-form-datepicker v-model="fdata.visiting_to_date" button-only right reset-button
                                        close-button locale="en" name="visiting_to_date_picker"
                                        :max="fdata.noc_type === 'travel' ? fdata.passport_expiry_date : null"></b-form-datepicker>
                                </b-input-group-append>
                                <!-- afrin 6-11 -->
                            </b-input-group>
                            <!-- update for error box -->
                            <b-form-invalid-feedback :state="validateState('visiting_to_date')">{{ veeErrors.first('visiting_to_date')
                                }}</b-form-invalid-feedback>
                        </b-form-group>
                    </div>
                    <!-- <div class="col-md-6">
                        <b-form-group label="Fiscal Year">
                            <b-form-select v-model="fdata.fiscal_year" :options="fiscal_years"></b-form-select>
                        </b-form-group>
                    </div>
                    <div class="col-md-6">
                        <b-form-group label="Month">
                            <b-form-select v-model="fdata.month" :options="months"></b-form-select>
                        </b-form-group>
                    </div> -->
                </div>

                <!-- <div class="mt-4 text-right">
                    <b-button variant="primary" type="submit" class="px-5">Save</b-button>
                    <b-button variant="secondary" @click="$bvModal.hide('bv-modal-noc')" class="px-5 ml-2">Cancel</b-button>
                </div> -->

                <b-form-group label=" " class="text-center mt-3" >

                    <b-button  @click="resetForm()" class="ml-2 btn-primary custom-wizard-btn" v-if="fdata.id < 1">Reset</b-button> <!-- Afrin: 7-14 update -->
                    <b-button variant="primary" type="submit" class="btn-primary">Submit</b-button>

                </b-form-group>
            </b-form>
        </b-modal>
    </div>
</template>

<script>
import moment from 'moment';

export default {
    props: ['flg'],
    data() {
        return {
            noc_documents: [],
            employee_info: {
                name: '',
                nationality: '',
                passport_no: ''
            },
            months: [
                { value: 0, text: "Select Month" }, { value: 1, text: "January" }, { value: 2, text: "February" },
                { value: 3, text: "March" }, { value: 4, text: "April" }, { value: 5, text: "May" },
                { value: 6, text: "June" }, { value: 7, text: "July" }, { value: 8, text: "August" },
                { value: 9, text: "September" }, { value: 10, text: "October" }, { value: 11, text: "November" },
                { value: 12, text: "December" }
            ],
            fiscal_years: this.$fiscal_year_options,
            filter_year: '',
            filter_month: 0,
            loader: false, // afrin 6-11
            fdata: {
                id: null,
                name: '',
                noc_type: 'general',
                nationality: '',
                passport_no: '',
                passport_issue_date: null,
                passport_expiry_date: null,
                visiting_destination: '',
                visiting_purpose: '',
                visiting_from_date: null,
                visiting_to_date: null,
                fiscal_year: this.getCurrentFinancialYear(),
                month: new Date().getMonth() + 1
            },
            // afrin 12-11
            general_cache: {
                visiting_purpose: '',
                visiting_from_date: null,
                visiting_to_date: null
            },
            travel_cache: {
                visiting_purpose: '',
                visiting_from_date: null,
                visiting_to_date: null,
                visiting_destination: '',
                selectedCountries: [],
                passport_issue_date: null,
                passport_expiry_date: null
            },
            // afrin 12-11
            statusMap: {
                0: 'Pending',
                1: 'Approved',
                2: 'Rejected'
            },
            search: '',
            length: 20,
            length_options: [
                { value: 20, text: "20" },
                { value: 50, text: "50" },
                { value: 100, text: "100" }
            ],
            sortKey: 'id',
            sortOrders: {
                employee_name: 1,
                employee_code: 1,
                noc_type: 1,
                visiting_destination: 1,
                visiting_purpose: 1,
                updated_at: 1,
                status: 1,
                id: -1
            },
            pagination: { currentPage: 1, total: '', nextPage: '', prevPage: '', from: '', to: '', pages: 1 },
            countries: [],
            selectedCountries: [],
            temp_country: null
        };
    },
    methods: {
        getNocs() {
            axios.get(this.$api_url + '/front/noc-document/list')
                .then(response => {
                    this.noc_documents = response.data.noc_documents;
                    this.employee_info = response.data.employee_info;

                    if (this.fdata.name == '') {
                        this.fdata.name = this.employee_info.name;
                        this.fdata.nationality = this.employee_info.nationality;
                        this.fdata.passport_no = this.employee_info.passport_no;
                    }
                    this.pagination.total = this.noc_documents.length;
                    this.pagination.pages = Math.ceil(this.noc_documents.length / this.length);
                })
                .catch(error => {
                    this.serverError(error);
                });
        },
        // Afrin: 7-14 update start
        addNew() {
            this.resetForm();
            this.$bvModal.show('bv-modal-noc');
        },
        resetForm() {
            this.fdata = {
                id: null,
                name: this.employee_info.name,
                noc_type: 'general',
                nationality: this.employee_info.nationality,
                passport_no: this.employee_info.passport_no,
                passport_issue_date: null,
                passport_expiry_date: null,
                visiting_destination: '',
                visiting_purpose: '',
                visiting_from_date: null,
                visiting_to_date: null,
                fiscal_year: this.getCurrentFinancialYear(),
                month: new Date().getMonth() + 1
            };
            this.selectedCountries = [];
            // afrin 6-11
            this.general_cache = {
                visiting_purpose: '',
                visiting_from_date: null,
                visiting_to_date: null
            };
            this.travel_cache = {
                visiting_purpose: '',
                visiting_from_date: null,
                visiting_to_date: null,
                visiting_destination: '',
                selectedCountries: [],
                passport_issue_date: null,
                passport_expiry_date: null
            };
            this.temp_country = null;
            // afrin 6-11
            this.$nextTick(() => {
                this.$validator.reset();
            });
        },
        // Afrin: 7-14 update end
        editNoc(id) {
            axios.get(this.$api_url + '/front/noc-document/details', { params: { id: id } })
                .then(response => {
                    this.fdata = response.data;
                    if (!this.fdata.noc_type) {
                        this.fdata.noc_type = 'travel';
                    }
                    this.selectedCountries = this.fdata.visiting_destination ? this.fdata.visiting_destination.split(',').map(c => c.trim()).filter(Boolean) : [];
                    this.$bvModal.show('bv-modal-noc');
                })
                .catch(error => {
                    this.serverError(error);
                });
        },
        // Afrin: 6-14 updated start
        deleteNoc(id) {
            this.$bvModal.msgBoxConfirm('Please confirm that you want to delete this application.', {
                title: 'Please Confirm',
                size: 'sm',
                buttonSize: 'sm',
                okVariant: 'primary',
                okTitle: 'Yes',
                cancelTitle: 'Cancel',
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true
            }).then(value => {
                if (value) {
                    axios.post(this.$api_url + '/front/noc-document/delete', { id: id })
                        .then(response => {
                            if (response.data.status) {
                                this.showSuccessToast(response.data.meg);
                                this.getNocs();
                            } else {
                                this.showErrorToast(response.data.meg || response.data.msg || 'Deletion failed.');
                            }
                        })
                        .catch(error => {
                            this.serverError(error);
                        });
                }
            });
        },
        approveNoc(id, status) {
            let msg = status === 1 ? 'approve' : 'reject';
            this.$bvModal.msgBoxConfirm('Please confirm that you want to ' + msg + ' this NOC.', {
                title: 'Please Confirm',
                size: 'sm',
                buttonSize: 'sm',
                okVariant: 'primary',
                okTitle: 'Yes',
                cancelTitle: 'Cancel',
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true
            }).then(value => {
                if (value) {
                    axios.post(this.$api_url + '/front/noc-document/approve', { id: id, status: status })
                        .then(response => {
                            if (response.data.status) {
                                this.showSuccessToast(response.data.meg);
                                this.getNocs();
                            } else {
                                this.showErrorToast(response.data.meg || response.data.msg || 'Approval failed.');
                            }
                        })
                        .catch(error => {
                            this.serverError(error);
                        });
                }
            });
        },
        // Afrin: 6-14 updated end
        onCountrySelect(value) {
            if (value && !this.selectedCountries.includes(value)) {
                this.selectedCountries.push(value);
                this.fdata.visiting_destination = this.selectedCountries.join(', ');
            }
            this.temp_country = null;
        },
        removeCountry(country) {
            this.selectedCountries = this.selectedCountries.filter(c => c !== country);
            this.fdata.visiting_destination = this.selectedCountries.join(', ');
        },
        // afrin 6-11
        onNocTypeChange(newVal) {
            if (this.fdata.id !== null) return;

            if (newVal === 'general') {
                this.travel_cache.visiting_purpose = this.fdata.visiting_purpose;
                this.travel_cache.visiting_from_date = this.fdata.visiting_from_date;
                this.travel_cache.visiting_to_date = this.fdata.visiting_to_date;
                this.travel_cache.visiting_destination = this.fdata.visiting_destination;
                this.travel_cache.selectedCountries = [...this.selectedCountries];
                this.travel_cache.passport_issue_date = this.fdata.passport_issue_date;
                this.travel_cache.passport_expiry_date = this.fdata.passport_expiry_date;

                this.fdata.visiting_purpose = this.general_cache.visiting_purpose;
                this.fdata.visiting_from_date = this.general_cache.visiting_from_date;
                this.fdata.visiting_to_date = this.general_cache.visiting_to_date;

                this.fdata.visiting_destination = '';
                this.selectedCountries = [];
                this.fdata.passport_issue_date = null;
                this.fdata.passport_expiry_date = null;
            } else if (newVal === 'travel') {
                this.general_cache.visiting_purpose = this.fdata.visiting_purpose;
                this.general_cache.visiting_from_date = this.fdata.visiting_from_date;
                this.general_cache.visiting_to_date = this.fdata.visiting_to_date;

                this.fdata.visiting_purpose = this.travel_cache.visiting_purpose;
                this.fdata.visiting_from_date = this.travel_cache.visiting_from_date;
                this.fdata.visiting_to_date = this.travel_cache.visiting_to_date;
                this.fdata.visiting_destination = this.travel_cache.visiting_destination;
                this.selectedCountries = [...this.travel_cache.selectedCountries];
                this.fdata.passport_issue_date = this.travel_cache.passport_issue_date;
                this.fdata.passport_expiry_date = this.travel_cache.passport_expiry_date;
                this.fdata.nationality = this.employee_info.nationality; // Afrin: 7-14 update
                this.fdata.passport_no = this.employee_info.passport_no; // Afrin: 7-14 update
            }

            this.$nextTick(() => {
                if (this.$validator) {
                    this.$validator.reset();
                }
            });
        },
        // afrin 6-11
        onSubmit() {
            if (this.fdata.noc_type === 'general') {
                this.fdata.nationality = '';
                this.fdata.passport_no = '';
                this.fdata.passport_issue_date = null;
                this.fdata.passport_expiry_date = null;
                this.fdata.visiting_destination = '';
            } else {
                this.fdata.visiting_destination = this.selectedCountries.join(', ');
            }
            this.loader = true; // Afrin 6-11
            this.$validator.validateAll().then(result => {
                // afrin 6-11
                if (!result) {
                    this.loader = false;
                    return;
                }
                // afrin 6-11
                // Afrin :update 6-9
                if (this.fdata.visiting_from_date && this.fdata.visiting_to_date) {
                    const start = moment(this.fdata.visiting_from_date);
                    const end = moment(this.fdata.visiting_to_date);
                    if (end.isBefore(start, 'day')) {
                        this.veeErrors.add({
                            field: 'visiting_to_date',
                            msg: 'End Date cannot be earlier than Start Date.'
                        });
                        this.loader = false; //afrin 6-11
                        return;
                    }
                }
                // afrin 6-11
                if (this.fdata.noc_type === 'travel' && this.fdata.passport_issue_date) {
                    const issue = moment(this.fdata.passport_issue_date);
                    const today = moment();
                    if (issue.isAfter(today, 'day')) {
                        this.veeErrors.add({
                            field: 'passport_issue_date',
                            msg: 'Passport Issue Date cannot be a future date.'
                        });
                        this.loader = false; // afrin 6-11
                        return;
                    }
                }
                if (this.fdata.noc_type === 'travel' && this.fdata.passport_issue_date && this.fdata.passport_expiry_date) {
                    const issue = moment(this.fdata.passport_issue_date);
                    const expiry = moment(this.fdata.passport_expiry_date);
                    if (expiry.isBefore(issue, 'day')) {
                        this.veeErrors.add({
                            field: 'passport_expiry_date',
                            msg: 'Passport Expiry Date cannot be earlier than Passport Issue Date.'
                        });
                        this.loader = false; // afrin 6-11
                        return;
                    }
                }
                // afrin 6-11
                if (this.fdata.noc_type === 'travel' && this.fdata.passport_expiry_date) {
                    const expiry = moment(this.fdata.passport_expiry_date);
                    if (this.fdata.visiting_from_date) {
                        const start = moment(this.fdata.visiting_from_date);
                        if (start.isAfter(expiry, 'day')) {
                            this.veeErrors.add({
                                field: 'visiting_from_date',
                                msg: 'Start Date cannot be after Passport Expiry Date.'
                            });
                            this.loader = false; //afrin 6-11
                            return;
                        }
                    }
                    if (this.fdata.visiting_to_date) {
                        const end = moment(this.fdata.visiting_to_date);
                        if (end.isAfter(expiry, 'day')) {
                            this.veeErrors.add({
                                field: 'visiting_to_date',
                                msg: 'End Date cannot be after Passport Expiry Date.'
                            });
                            this.loader = false; //afrin 6-11
                            return;
                        }
                    }
                }
                // Afrin :update 6-9
                axios.post(this.$api_url + '/front/noc-document/save', this.fdata)
                    .then(response => {
                        this.loader = false; // afrin 6-11
                        if (response.data.status) {
                            this.showSuccessToast(response.data.msg);
                            this.$bvModal.hide('bv-modal-noc');
                            this.getNocs();
                        } else {
                            this.showErrorToast(response.data.msg || 'Save failed.');
                        }
                    })
                    .catch(error => {
                        this.loader = false; // afrin 6-11
                        this.serverError(error);
                    });
                    // afrin 6-11
            }).catch(() => {
                this.loader = false;
            });
            // afrin 6-11
        },
        downloadNoc(id) {
            axios.post(this.$api_url + '/front/noc-document/download-single', { id: id })
                .then(response => {
                    if (response.data.status) {
                        this.downloadFileContent(response.data.file_link);
                    } else {
                        this.showErrorToast(response.data.msg || 'Failed to download NOC document.');
                    }
                })
                .catch(error => {
                    this.serverError(error);
                });
        },

        format_date(date) {
            if (date) {
                return moment(date).format('DD-MMM-YYYY');
            }
            return '';
        },
        format_datetime(date) {
            if (date) {
                return moment(date).format('DD-MMM-YYYY hh:mm A');
            }
            return '';
        },
        // Afrin: edited 6-25-26 start
        getCountryText(value) {
            if (!value) return '';
            const country = this.countries.find(c => String(c.value) === String(value));
            return country ? country.text : value;
        },
        // Afrin: edited 6-25-26 end
        getCountryPairs(destination) {
            if (!destination) return [];
            const countries = destination.split(',').map(c => c.trim()).filter(Boolean);
            const resolvedNames = countries.map(c => this.getCountryText(c)); // Afrin: edited 6-25-26
            const pairs = [];
            // Afrin: edited 6-25-26 start
            for (let i = 0; i < resolvedNames.length; i += 2) {
                pairs.push(resolvedNames.slice(i, i + 2).join(', '));
            }
            // Afrin: edited 6-25-26 end
            return pairs;
        },
        resetPagination() {
            this.pagination.currentPage = 1;
        },
        sortBy(key) {
            this.sortKey = key;
            this.sortOrders[key] = this.sortOrders[key] * -1;
            this.resetPagination();
        },
        validateState(ref) {
            if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
                return !this.veeErrors.has(ref);
            }
            return null;
        },
        showSuccessToast(msg) {
            this.$bvToast.toast(msg, {
                title: 'Success',
                variant: 'success',
                solid: true
            });
        },
        showErrorToast(msg) {
            this.$bvToast.toast(msg, {
                title: 'Error',
                variant: 'danger',
                solid: true
            });
        },
        getCountries() {
            axios.get(this.$api_url + '/front/noc-document/countries')
                .then(response => {
                    this.countries = response.data;
                })
                .catch(error => {
                    this.serverError(error);
                });
        }
    },
    computed: {
        // afrin 6-11
        maxPassportIssueDate() {
            return moment().format('YYYY-MM-DD');
        },
        // Afrin: 7-14 update start
        totalPages() {
            return Math.ceil(this.filteredData.length / this.length) || 1;
        },
        // Afrin: 7-14 update end
        filteredData() {
            let filtered_list = this.noc_documents;
            if (this.filter_year) {
                filtered_list = filtered_list.filter((row) => {
                    return row.fiscal_year === this.filter_year;
                });
            }
            if (this.filter_month) {
                filtered_list = filtered_list.filter((row) => {
                    return row.month == this.filter_month;
                });
            }
            if (this.search) {
                const searchLower = this.search.toLowerCase();
                filtered_list = filtered_list.filter((row) => {
                    // Afrin :update 6-9
                    const empName = (row.employee && row.employee.name) ? row.employee.name : ''; // Afrin: 7-14 update 
                    const empCode = (row.employee && row.employee.employee_code) ? row.employee.employee_code : ''; // Afrin: 7-14 update
                    const nocType = row.noc_type === 'general' ? 'general' : 'travel';
                    const purpose = row.visiting_purpose || '';
                    const destination = row.noc_type === 'general' ? 'n/a' : (row.visiting_destination ? row.visiting_destination.split(',').map(c => this.getCountryText(c.trim())).join(', ') : ''); // Afrin: 7-14 update
                    const statusText = this.statusMap[row.status] || '';
                    return empName.toLowerCase().includes(searchLower) ||
                           empCode.toLowerCase().includes(searchLower) ||
                           nocType.includes(searchLower) ||
                           purpose.toLowerCase().includes(searchLower) ||
                           destination.toLowerCase().includes(searchLower) ||
                           statusText.toLowerCase().includes(searchLower);
                });
            }

            let sortKey = this.sortKey;
            let order = this.sortOrders[sortKey] || 1;
            if (sortKey) {
                filtered_list = filtered_list.slice().sort((a, b) => {
                    let a_val = a[sortKey];
                    let b_val = b[sortKey];

                    if (sortKey === 'employee_name') {
                        // Afrin :update 6-9
                        a_val = a.employee ? a.employee.name : '';
                        b_val = b.employee ? b.employee.name : '';
                    } else if (sortKey === 'employee_code') {
                        a_val = a.employee ? a.employee.employee_code : '';
                        b_val = b.employee ? b.employee.employee_code : '';
                    } else if (sortKey === 'updated_at') {
                        a_val = a.updated_at || a.created_at || '';
                        b_val = b.updated_at || b.created_at || '';
                    }

                    if (a_val === null) a_val = '';
                    if (b_val === null) b_val = '';

                    a_val = String(a_val).toLowerCase();
                    b_val = String(b_val).toLowerCase();

                    if (!isNaN(parseFloat(a_val)) && !isNaN(parseFloat(b_val)) && isFinite(a_val) && isFinite(b_val)) {
                        return (+a_val === +b_val ? 0 : +a_val > +b_val ? 1 : -1) * order;
                    } else {
                        return (a_val === b_val ? 0 : a_val > b_val ? 1 : -1) * order;
                    }
                });
            }

            return filtered_list;
        },
        paginatedData() {
            if (this.paginate) {
                return this.paginate(this.filteredData, this.length, this.pagination.currentPage);
            } else {
                // Fallback if paginate mixin is missing
                const start = (this.pagination.currentPage - 1) * this.length;
                const end = start + this.length;
                return this.filteredData.slice(start, end);
            }
        }
    },
    created() {
        this.getNocs();
        this.getCountries();
    }
};
</script>
